module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, _vm._l((_vm.problem_list), function(item, index, key) {
    return _c('div', {
      key: index,
      staticClass: "example-problem"
    }, [_c('div', {
      staticClass: "example-problem-main"
    }, [_c('h2', [_vm._v(_vm._s(item.example_problems))]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(item.way) + "\n            ")]), _vm._v(" "), _vm._m(0, true, false)])])
  }))
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "remain"
  }, [_vm._v("\n                remain to be solved\n                "), _c('img', {
    staticClass: "remain-icon",
    attrs: {
      "src": require("../../../assets/fold.png"),
      "width": "10"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1132b5f3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Services/tabs/services_mogos.vue
// module id = 782
// module chunks = 0